"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CN_MARKET = void 0;
const CN_MARKET = exports.CN_MARKET = 'cn';
